<template>
  <div class="batch-upload-candidate-layout">
    <div class="upload-menu">
      <el-menu class="menu-list" :default-active="currentActiveIndex" active-text-color="#0096cc">
        <el-menu-item v-for="(item, index) in menuList" :key="index" :index="`${index}`" @click="handleMenuClick(item)">
          <span>{{ item.label }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="upload-content">
      <div class="breadcrumb" separator="/">
        <span v-if="fromApplicant"  class="navigation"  @click="handleBreadCrumbNavigationClick">{{ $t(`${i18nPrefix}.btn.backUniversal`) }}</span>
        <span v-else-if="jobId === '-1'"  class="navigation" @click="handleBreadCrumbNavigationClick">{{ $t(`${i18nPrefix}.btn.backTalentPoll`) }}</span>
        <span v-else  class="navigation"  @click="handleBreadCrumbNavigationClick">{{ jobName }}</span>
        <span class="split">/</span>
        <span v-if="currentActiveIndex === '0'" class="navigation active">{{ $t(`${i18nPrefix}.btn.openUploader`) }}</span>
        <span v-else class="navigation active">{{ $t(`${i18nPrefix}.btn.viewHistory`) }}</span>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'

export default {
  components: {

  },
  data () {
    return {
      i18nPrefix: 'admin.application.batchUpload',
      activeMenuIndex: null,
      jobName: null
    }
  },
  computed: {
    currentActiveIndex () {
      if (this.activeMenuIndex) {
        return this.activeMenuIndex
      } else {
        const currentIndex = _.findIndex(this.menuList, item => item.link === this.$route.fullPath)
        return `${currentIndex}`
      }
    },
    fromApplicant () {
      return this.$route.query.from_applicant === '1'
    },
    talentGroupId () {
      return this.$route.query.talent_pool
    },
    jobId () {
      return this.$route.params.jobId
    },
    backPath () {
      return this.$route.query.back || ''
    },
    isUploadPage () {
      return this.$route.meta.isUploader
    },
    menuList () {
      const basePath = `/v-admin/application/${this.jobId}/batch-upload`
      const vm = this
      return [
        {
          hidden: this.isUploadPage,
          label: this.$t(`${this.i18nPrefix}.btn.openUploader`),
          get link () {
            if (vm.fromApplicant) {
              return `${basePath}/uploader?from_applicant=1`
            } else if (vm.talentGroupId) {
              return `${basePath}/uploader?talent_pool=${vm.talentGroupId}`
            } else {
              return `${basePath}/uploader`
            }
          },
          isInclude: true
        },
        {
          hidden: !this.isUploadPage,
          label: this.$t(`${this.i18nPrefix}.btn.viewHistory`),
          get link () {
            if (vm.fromApplicant) {
              return `${basePath}/history?from_applicant=1`
            } else if (vm.talentGroupId) {
              return `${basePath}/history?talent_pool=${vm.talentGroupId}`
            } else {
              return `${basePath}/history`
            }
          },
          isInclude: true
        }
      ]
    }
  },
  created () {
    this.loadJobInfo()
  },
  methods: {
    ...mapActions('job', ['getJobInfo']),
    async loadJobInfo () {
      if (!this.jobId || this.jobId === '-1') {
        return
      }
      const resp = await this.getJobInfo({ jobId: this.jobId })
      if (resp) {
        const job = resp.job
        addI18nProperty(job, 'jobName', 'cn_name', 'name')
        this.jobName = job.jobName
      }
    },
    handleMenuClick (menuItem) {
      if (this.$route.path === menuItem.link) {
        return
      }
      const currentIndex = _.findIndex(this.menuList, menuItem)
      this.activeMenuIndex = `${currentIndex}`
      if (menuItem.isInclude) {
        this.$router.push(menuItem.link)
      } else {
        window.location.href = menuItem.link
      }
    },
    handleBreadCrumbNavigationClick () {
      const query = this.$route.query
      let url = ''
      if (this.fromApplicant) {
        url = '/v-admin/application'
      } else if (this.jobId === '-1') {
        url = `/v-admin/talent-pool/${this.talentGroupId || '-1'}`
      } else {
        url = `/v-admin/job/${this.jobId}/application/`
      }
      if (query.back) {
        url = query.back
      }
      this.$router.push(url)
    }
  },
  watch: {
    $route: {
      handler () {
        const currentIndex = _.findIndex(this.menuList, item => item.link === this.$route.fullPath)
        this.activeMenuIndex = `${currentIndex}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-upload-candidate-layout {
  padding-left: 0;
  margin-left: -24px;
  min-height: 100%;
  display: flex;
  margin-right: -6px;
  .upload-menu {
    flex-grow: 0;
    width: 280px;
    background: #FFFFFF;
    box-shadow: 3px -1px 6px -3px rgb(0 0 0 / 12%);
    margin: -18px 0;

    .menu-list {
      border: 0;
      .el-menu-item {
        padding: 0 16px !important;
      }
    }
  }

  .upload-content {
    flex-grow: 1;
    margin-left: 18px;
    min-width: 1024px;
    overflow: hidden;
    margin-top: -20px;

    .breadcrumb {
      font-size: 14px;
      font-weight: 400;
      margin: 14px 0;

      .navigation {
        cursor: pointer;
        color: #0096cc;

        &.active {
          cursor: default;
          color: #606266;
        }
      }

      .split {
        margin: 0 5px;
      }
    }

    .content {
      background: #fff;
      padding: 28px 24px 0 24px;
      min-height: 100%;
    }

  }
}
</style>
